export default __webpack_public_path__ + "static/media/Truck-empty-state-icon.d95cb13f.svg";